export default "__VITE_ASSET__CIEaYJF___"